import axiosInstance from 'helpers/axiosInstance';

export const getExpiredAgreementsForPatient = async (patientId: string) => {
  const url = `/patients/agreements/${patientId}/expired`;
  return axiosInstance.get(`${url}`).then(r => r.data);
};
